import { Laugh, Smile, Sparkles, Moon, CloudRain, Frown, Angry } from "lucide-react";

const ICONS = { happy: Laugh, calm: Smile, excited: Sparkles, tired: Moon, worried: CloudRain, sad: Frown, angry: Angry };

export const FeelingIcon = ({ feeling, className = "w-5 h-5" }) => {
  const Icon = ICONS[feeling] || Smile;
  return <Icon className={className} />;
};
